import React, { memo } from "react";
import styled from "styled-components";

// Mirrors backend BATTERY_LOW_THRESHOLD (cloud_core/settings.py): the warning
// shows strictly below 30% — i.e. 29% or lower.
export const LOW_BATTERY_THRESHOLD = 30;
export const LOW_BATTERY_MESSAGE = "Please Charge The Vehicle";

export function isLowBattery(batteryLevel: number | null | undefined): boolean {
  if (batteryLevel == null || isNaN(batteryLevel)) return false;
  return batteryLevel < LOW_BATTERY_THRESHOLD;
}

// Matches the BatteryIndicator "red" fill color.
const LowBatteryWarningStyled = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #c62828;
`;

interface LowBatteryWarningProps {
  batteryLevel: number | null | undefined;
  // Offline vehicles shouldn't ask to be charged — their battery reading is
  // stale anyway. Callers pass their surface's offline signal here.
  offline?: boolean;
  className?: string;
}

// Renders nothing unless the battery is low, so callers can drop it in
// unconditionally. className is forwarded so surfaces can resize it via
// styled(LowBatteryWarning).
export const LowBatteryWarning = memo<LowBatteryWarningProps>(
  ({ batteryLevel, offline, className }) => {
    if (offline || !isLowBattery(batteryLevel)) {
      return null;
    }

    return (
      <LowBatteryWarningStyled
        className={className}
        data-test-id="low-battery-warning"
      >
        ⚠ {LOW_BATTERY_MESSAGE}
      </LowBatteryWarningStyled>
    );
  }
);

LowBatteryWarning.displayName = "LowBatteryWarning";
